@if (vm$ | async; as vm) {
  <div class="container">
    @if (vm.customerLoadState.loading) {
      <div class="customer-loading">
        <div class="loading-container">
          <div class="loading-content">
            <ion-spinner name="crescent"></ion-spinner>
            <p>Loading your details...</p>
          </div>
        </div>
      </div>
    } @else {
      @if (!vm.progressError || vm.progressError.canRetry) {
        <div class="payment-container">
          <div class="payNowContainer">
            <div class="header">AMOUNT TO PAY NOW</div>
            <div class="amount" (click)="vm.canEditAmount ? onEditAmount() : null">
              <span>£{{ (vm.payNowAmount / 100).toFixed(2) }}</span>
              @if (vm.canEditAmount) {
                <ion-icon name="pencil-outline"></ion-icon>
              }
            </div>
            <div class="footer">
              <ion-icon name="information-circle-outline"></ion-icon
                ><span> {{ vm.canEditAmount ? 'Split payments allowed' : 'Single payment required' }}</span>
              </div>
            </div>
            <hr />
            <!-- Duplicated outside the ng-template since we want to place it above the pay button when canRetry is true -->
            @if (vm.progressError?.message && vm.progressError.canRetry) {
              <div class="outerPaymentErrorCont">
                <div class="paymentErrorCont">
                  <p>{{ vm.progressError.message }}</p>
                </div>
              </div>
            }
            @if (vm.canPayWithGooglePay) {
              <div class="paymentButton googlePayButton">
                <ion-button class="google-pay-button" color="black" (click)="onPayWithGooglePay()">
                  <div class="google-pay-button-content"></div>
                </ion-button>
              </div>
            }
            @if (vm.canPayWithApplePay) {
              <div class="paymentButton applePayButton">
                <ion-button class="apple-pay-button apple-pay-button-black" fill="clear" (click)="onPayWithApplePay()">
                </ion-button>
              </div>
            }
            @if (vm.canPayWithGooglePay || vm.canPayWithApplePay) {
              <div class="orSeparator">OR</div>
            }
            @if (vm.paymentMethod) {
              <div class="cardForm">
                <div class="paymentButton cardPayButton">
                  <ion-button
                    [ngClass]="vm.platformButtonClass"
                    class="paymentButton"
                    shape="round"
                    color="secondary"
                    (click)="onConfirm()"
                    >Pay with card <span class="asterisks">&nbsp;&nbsp;****&nbsp;</span>
                    {{ vm.paymentMethod?.cardLast4 }}</ion-button
                    >
                  </div>
                  <div class="methodContainer">
                    <ion-button class="secondaryTextLink" type="button" fill="clear" (click)="onChooseMethod()"
                      >CHANGE METHOD
                    </ion-button>
                  </div>
                </div>
              }
              <div class="paymentButton cardPayButton">
                @if (!vm.paymentMethod) {
                  <ion-button
                    [ngClass]="vm.platformButtonClass"
                    class="paymentButton"
                    shape="round"
                    color="secondary"
                    (click)="onChooseMethod()"
                    >Add / Select Card</ion-button
                    >
                  }
                </div>
              </div>
            }
          }
          <!-- Duplicated inside the above ng-template since we want to place it above the pay button when canRetry is true -->
          @if (vm.progressError?.message && !vm.progressError.canRetry) {
            <div class="outerPaymentErrorCont">
              <div class="paymentErrorCont">
                <p>{{ vm.progressError.message }}</p>
              </div>
            </div>
          }
        </div>
      }
